import type { StoreState } from '../../state-types';
import { byPriority } from './get-core-question-active-list-by-short-id';

export const getCoreQuestionSortedIdList = (state: StoreState): string[] =>
    Object.values(state.coreQuestions)
        .sort(byPriority)
        .map((q) => q.id);
